export const DEFAULT_DIMENSIONS = {
    COLUMNS: 7,
    ROWS: 6
}